import { persist } from 'zustand/middleware';
import { createAndResetOnLogout } from 'stores/utils';
import {
  GraphQLDocumentObjectType,
  GraphQLLeaseDocumentObjectType,
} from 'types/documents-types';

type UserDocumentsStore = {
  userDocuments?: GraphQLDocumentObjectType[];
  userTaxesDocuments?: GraphQLDocumentObjectType[];
  userLeasesDocuments?: GraphQLLeaseDocumentObjectType[];
  setUserDocuments: (documents: GraphQLDocumentObjectType[]) => void;
  setTaxesDocuments: (documents: GraphQLDocumentObjectType[]) => void;
  setLeasesDocuments: (documents: GraphQLLeaseDocumentObjectType[]) => void;
};

export const useUserDocumentsStore =
  createAndResetOnLogout<UserDocumentsStore>()(
    persist(
      (set) => ({
        userDocuments: [],
        userTaxesDocuments: [],
        userLeasesDocuments: [],
        setUserDocuments: (userDocuments: GraphQLDocumentObjectType[]) =>
          set({ userDocuments }),
        setTaxesDocuments: (userTaxesDocuments: GraphQLDocumentObjectType[]) =>
          set({ userTaxesDocuments }),
        setLeasesDocuments: (
          userLeasesDocuments: GraphQLLeaseDocumentObjectType[]
        ) => set({ userLeasesDocuments }),
      }),
      { name: 'documents' }
    )
  );
